import { render } from "./DataMapperStreaming.vue?vue&type=template&id=2af53dd4&scoped=true"
import script from "./DataMapperStreaming.vue?vue&type=script&lang=js"
export * from "./DataMapperStreaming.vue?vue&type=script&lang=js"

import "./DataMapperStreaming.vue?vue&type=style&index=0&id=2af53dd4&lang=scss&scoped=true"
import "./DataMapperStreaming.vue?vue&type=style&index=1&id=2af53dd4&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af53dd4"]])

export default __exports__